import { useInfiniteQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { NewsInterface } from "../interfaces/news_interface";
import { NewsRepositoryImpl } from "../../data/repository/news_repository_impl";
import { useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import { UserInterface } from "../../../user/domain/interfaces/user_interface";

interface PaginatedNewsResponse {
    news: NewsInterface[];
    fetchedAll: boolean
}

export const useGetNews = (limit: number = 10) => {
    const repository = new NewsRepositoryImpl();
    const { company } = useOutletContext<UserInterface>();

    const query = useInfiniteQuery<PaginatedNewsResponse, AxiosError>({
        queryKey: ['newsList', limit, company?.id],
        queryFn: async ({ pageParam = 0, }) => {
            const result = await repository.getNews(pageParam as number, limit);
            
            return {
                news: result.news,
                fetchedAll: result.fetchedAll
            };
        },
        retry: 4,
        staleTime: 20 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        getNextPageParam: (lastPage, allPages) => {
            const currentPageNumber = allPages.length;
            
            if (!lastPage.fetchedAll) {
                return currentPageNumber * limit;
            }
            return undefined;
        },
        initialPageParam: 0,
    });

    const allNews = useMemo(() => {
        const meetings = query.data?.pages.flatMap(page => page.news) || [];
        return meetings;
    }, [query.data]);

    return { ...query, allNews };
};